var islington = window.islington || {};

/*All URL's used in AJAX request*/
islington.url = {
    uploadDocument: "/lbi-api/formdocumentsapi/upload",
    deleteDocument: "/lbi-api/formdocumentsapi/Delete",
    addAddress: "/BusinessAccount/BusinessRatesForms/AddAddress",
    removeAddress: "/BusinessAccount/BusinessRatesForms/RemoveAddress"
};

islington.formatSignature = {
    png: "89504e47", jpeg:"ffd8ffe2", gif:"47494638",
    pdf: "25504446",
    //doc: "d0cf11e0"    
};
//txt: "76617220",76667666, fffe2a0, 312e2044,67697420,da4973,42657374
/*
*Checks whether string is empty (ignores whitespaces)
*/
islington.isEmpty = function (str) {
    return (str == null) || (typeof str == "string" && !str.trim())
    || (typeof str == "undefined");
};

//adds is-empty class if there is nor left vertical navigation. Used on SBRR form
if (islington.isEmpty($(".l-verticalNavigationContainer .l-navigation").html())) {
    $(".l-verticalNavigationContainer .l-navigation").
        addClass("is-empty");
}


/*
checks if variable has valid value
x- variable to check validity for
*/
islington.checkValidity = function (x) {
    if (x == undefined ||
     x == null || x == NaN || (typeof x == "object" && x.length == 0)) {
        return false
    }

    return true;
};

/*
checks variable validity + also checks if string is empty
x- variable to check validity for
*/
islington.checkValidityPlusStringEmptiness = function (x) {
    if (this.checkValidity(x) && !this.isEmpty(x))
        return true;
    else
        return false;
};

/*
returns data-id Element
x- data-id value
*/
islington.dataIdElement = function (x) {
    try {
        if (typeof x == "string" && !islington.isEmpty(x))
            selector = "[data-id=" + x + "]";
        else
            throw ("data-id is either not string or empty");
        return $(selector);
    } catch (err) {
        console.log(err);
    }
};

/*
finds nearest element even in another tree(as jquery closest only finds elements as parent and siblings in the same level
so ween need a function which can find nearest elements even in different tree. This
function is especially useful to find nearest progressbar for docupload, which
saves backend developers work of binding through ids  )
********************Params****************************************
fromStart- selector of element to start
toFind- selector of element to find
iteration- how many levels up it needs to serach
*/
islington.findNearestElement = function (fromStart, toFind, iteration) {
    if (!this.checkValidity(iteration))
        iteration = 2;

    var parent = $(fromStart).parent();

    for (var i = 0; i < iteration; ++i) {
        var result = parent.find(toFind),
        isFound = this.checkValidity(result);
        if (isFound)
            break;
        parent = parent.parent();
    }

    return result;
};

/*Checks whether file extension is supported or not within a list of formats
********************Params****************************************
fileName- is a file's name which includes its extension eg. close.png
formats- is a string of comma separated extension eg. ".png,.svg"
requestType- has two possible values "accept" or "reject" 
*/
islington.isFileSupported = function (file, formats, requestType) {
    if (!this.checkValidity(file) ||
    !this.checkValidity(formats) || this.isEmpty(formats))
        return true;
    fileName = file.name;
    requestType = requestType || "reject";

    var supportedFormatsArray = formats.split(','),
    filenameSplited = fileName.split('.'),
    fileFormat = filenameSplited[filenameSplited.length - 1].toLowerCase(),
    MultimediaFormats = {
        image: ["png", "jpg", "jpeg", "svg", "tiff", "giff", "bmp"]
        , audio: ["mp3", "ogg", "3gp", "aac", "wav", "aiff", "wma"],
        video: ["mp4", "avi", "flv", "mov", "wmv"]
    },
    pattern = "";
    //reject="^((?!png|svg).)*$", accept="^(svg|png)$"
    for (var i in supportedFormatsArray) {
        var val = supportedFormatsArray[i],
        isMultimediaFormat = val.split('/').length > 1;

        if (isMultimediaFormat) {
            var formatType = val.split('/')[0],
                formats = MultimediaFormats[formatType];
            for (var j in formats) {
                var format = formats[j];
                pattern += format + "|";
            }
        }
        else {
            val = val.replace(/\s/g,"").replace(".","");
            pattern += val + "|";
        }
    }

    pattern = pattern.
        substring(0, pattern.length - 1);

    if (requestType == "accept")
        pattern = "^(" + pattern + ")$";
    else
        pattern = "^((?!" + pattern + ").)*$";

    var regex = new RegExp(pattern),
        isFormatSupported = regex.test(fileFormat);

    return isFormatSupported;
};


//islington.isMIMESupported = function(file, formats)

/*Converts bytes to the effective unit if morethan 1024 bytes then shows KB or if more than kb limit
then shows MB
********************Params****************************************
bytes(Type Number)- Size value
stringOutput(Type Boolean)- true to get string rather than object  
returns a object ex.  {unit:"KB",size:4} unless 
*/
islington.fileSizeEffectiveUnitCoverter = function (bytes, stringOutput) {
    var covertedObj, sizes = {
        mbsize: 1024 * 1024,
        kbsize: 1024
    };
    if (arguments.length > 0) {
        if (bytes >= sizes.mbsize)
            covertedObj = { unit: "MB", size: bytes / sizes.mbsize }
        else if (bytes >= sizes.kbsize)
            covertedObj = { unit: "KB", size: bytes / sizes.kbsize }
        else
            covertedObj = { unit: "bytes", size: bytes }

        covertedObj.size = covertedObj.size.toFixed(2);

        if (stringOutput)
            return covertedObj.size + " " + covertedObj.unit;
        else
            return covertedObj;
    }
};

/*Allows messaging to screenreaders. Checks for existence of an alert
 * with specific id, if not present then creates it and adds to DOM
********************Params****************************************
message- string, message to be read out by screenreader
elementId- string, id of the screenreader alert element
*/
islington.giveScreenreaderAlert = function (message, elementId) {
    let $alert = $(`[id=${elementId}]`);
    if ($alert.length) {
        $alert.text('');
    } else {
        $alert = $(`<div class='visually-hidden' role='alert' id='${elementId}' />`);
        $('body').append($alert);
    }

    $alert.text(message)
}

islington.clearScreenreaderAlert = function (id) {
    setTimeout(() => {
        islington.giveScreenreaderAlert('', id);
    }, 1000)
}

